import styled from 'styled-components';
import Box from '../../../../../_shared/components/Box';
import { StyledBadge } from '../Styles';
import Badge from '../../../../../_shared/components/Badge';

export const DisclosureBox = styled(Box)`
  padding-top: 16px;
  justify-content: initial;
  align-items: flex-start;
`;

export const InStock = StyledBadge;

export const QandA = StyledBadge;

export const HasDisclosures = styled(StyledBadge)`
  border: 1px solid ${({ theme }) => theme.COLORS.ORANGE};
`;

export const AsIs = styled(Badge)`
  background-color: ${({ theme }) => theme.COLORS.ORANGE};
  border: 1px solid ${({ theme }) => theme.COLORS.ORANGE};
  border-radius: 18px;
  margin-right: 10px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  height: 20px;
  min-width: 47px;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
